import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkTokenValidation, clearAuthStorage, isCustomerUser } from "../helper";
import Header from "./Header/Header";
import CustomerNavbar from "./Header/CustomerNavbar";
import { getNavbar } from "src/Requests/headerRequests";
import { INavbarItem } from "src/Interfaces/NavbarInterfaces";
import { toast } from "react-toastify";
import { FullScreenLoading } from "src/Components";
import { IGlobalTab } from "src/Interfaces/commonDtos";

interface IMasterPage {
  children: React.ReactNode;
}

export const ServerTabsContext = createContext<{ [key: string]: IGlobalTab }>(
  {}
);

const MasterPage = ({ children }: IMasterPage) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);
  const isCustomer = isCustomerUser();

  const [loading, setLoading] = useState<boolean>(false);
  const [navbarItems, setNavbarItems] = useState<Array<INavbarItem> | null>(
    null
  );
  const [tabs, setTabs] = useState<{ [key: string]: IGlobalTab }>({});

  useEffect(() => {
    if (isCustomer) return;
    setLoading(true);
    getNavbar()
      .then((res) => {
        setNavbarItems(res);
        const tabs: { [key: string]: IGlobalTab } = {};
        res.forEach((firstLayer) => {
          if (firstLayer.children && firstLayer.children.length) {
            firstLayer.children.forEach((secondLayer) => {
              tabs[secondLayer.address?.split("?")[0] || "#"] = {
                tabs: secondLayer.tabs,
              } as IGlobalTab;
            });
          }
        });
        setTabs(tabs);
      })
      .catch(() => {
        toast.error("عدم ارتباط با سرور");
      })
      .finally(() => setLoading(false));
  }, []);

  React.useEffect(() => {
    navigateToLoginIfInValidToken();
    setInterval(() => {
      navigateToLoginIfInValidToken();
    }, 60000);
    if (isOpen) setIsOpen(false);
  }, [location]);

  const navigateToLoginIfInValidToken = () => {
    if (!checkTokenValidation()) {
      clearAuthStorage();
      navigate("/", {
        state: {
          errorMsg: "زمان دسترسی شما به پایان رسیده است لطفا دوباره وارد شوید",
        },
      });
    }
  };

  return (
    <div className="max-w-full">
      {loading ? <FullScreenLoading /> : <></>}
      {!isCustomer && <Header navbarItems={navbarItems} />}
      {isCustomer && <CustomerNavbar />}
      <ServerTabsContext.Provider value={tabs}>
        <div className="w-full max-w-full overflow-x-auto outline-none">
          {children}
        </div>
      </ServerTabsContext.Provider>
    </div>
  );
};

export default MasterPage;
